export default "__VITE_ASSET__B2XGPO2u__"